import { ContactHeader } from './ContactHeader';
import { ContactNotes } from './ContactNotes';
import { ContactConnectionsSidebar } from './ContactConnectionsSidebar';
import { ContactInterests } from './ContactInterests';
import { ContactGroups } from './ContactGroups';
import { ContactImportantDates } from './ContactImportantDates';
import { Tag, Calendar, Users } from 'lucide-react';

interface ContactSidebarProps {
  contact: {
    id: string;
    first_name: string;
    last_name: string;
    job_title?: string;
    company_name?: string;
    primary_email?: string | null;
    last_contacted: string | null;
    rank?: string;
    next_contact?: string | null;
  };
  onUpdate: () => void;
}

export function ContactSidebar({ contact, onUpdate }: ContactSidebarProps) {
  return (
    <div className="pb-8 px-3 space-y-4">
      {/* Contact Header with border */}
      <div className="rounded-lg border bg-card/50 shadow-sm p-4 mt-4">
        <ContactHeader contact={contact} onUpdate={onUpdate} />
      </div>

      {/* Notes Section */}
      <div className="rounded-lg border bg-muted/10 p-4" data-tour-id="contact-detail.notes">
        <ContactNotes contactId={contact.id} />
      </div>

      {/* Connections Section */}
      <ContactConnectionsSidebar contactId={contact.id} />

      {/* Interests Section */}
      <div className="rounded-lg border p-4" data-tour-id="contact-detail.interests">
        <div className="flex items-center gap-2 mb-2">
          <Tag className="h-4 w-4 text-primary/70" />
          <h3 className="font-semibold text-sm">Interests</h3>
        </div>
        <ContactInterests
          contactId={contact.id}
          onUpdate={onUpdate}
        />
      </div>

      {/* Important Dates Section */}
      <div className="rounded-lg border p-4">
        <div className="flex items-center gap-2 mb-2">
          <Calendar className="h-4 w-4 text-primary/70" />
          <h3 className="font-semibold text-sm">Important Dates</h3>
        </div>
        <ContactImportantDates contactId={contact.id} />
      </div>

      {/* Groups Section */}
      <div className="rounded-lg border p-4" data-tour-id="contact-detail.groups">
        <div className="flex items-center gap-2 mb-2">
          <Users className="h-4 w-4 text-primary/70" />
          <h3 className="font-semibold text-sm">Groups</h3>
        </div>
        <ContactGroups contactId={contact.id} />
      </div>
    </div>
  );
}